module.exports = __webpack_public_path__ + "static/stava-og-image-7755f01b06e263142de4d6e4f4e33142.jpg";